import { useStoreState } from '../store';
import { ConfigProvider } from 'antd';
import type { FC, PropsWithChildren } from 'react';

export const WithConfigProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const locale = useStoreState((state) => state.i18n.activeLocale);
  const localeMap = useStoreState((state) => state.i18n.localeMap);
  return <ConfigProvider locale={localeMap[locale]}>{children}</ConfigProvider>;
};
